import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  userData: any | null;
  loading: boolean;
  error: boolean;
  accessToken: string | null;
  refreshToken: string | null;
}

const initialState: AuthState = {
  userData: null,
  loading: true,
  error: false,
  accessToken: null,
  refreshToken: null
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setData: (state, action: PayloadAction<{
      data: any;
      accesstoken: string;
      refreshtoken: string;
    }>) => {
      state.userData = action.payload.data;
      state.accessToken = action.payload.accesstoken;
      state.refreshToken = action.payload.refreshtoken;
      state.loading = false;
      state.error = false;
    },
    clearData: (state) => {
      state.userData = null;
      state.accessToken = null;
      state.refreshToken = null;
      state.loading = false;
      state.error = false;
    }
  },
});

export const { setData, clearData } = authSlice.actions;
export default authSlice.reducer;
